module.exports = __webpack_public_path__ + "static/software-development-sydney-valor-7af45c291f7701c755ff4def59701887.jpg";